export const FAVES_START_YEAR = 2025;

// Social OAuth "start" routes -- each kicks off the server-side OAuth flow for one
// platform. Centralized because the ?intent=/?next= query params were being appended
// ad hoc per call site and had already drifted (bare vs. ?intent=reauth vs.
// ?intent=connect) across a dozen entrypoints.
export enum SocialOAuthIntent {
  Connect = 'connect',
  Reauth = 'reauth',
}

export const INSTAGRAM_OAUTH_START_PATH = '/instagram/start';
// Skips the Facebook Page step -- Instagram-only login (Business Login) flow.
export const INSTAGRAM_ONLY_OAUTH_START_PATH = '/instagram/only/start';
// Step-by-step Facebook Business Login tutorial page (opened in a new tab from connect CTAs).
export const FACEBOOK_BUSINESS_LOGIN_GUIDE_PATH = '/portal/facebook-business-login-guide';
export const TIKTOK_OAUTH_START_PATH = '/tiktok/start';
export const YOUTUBE_OAUTH_START_PATH = '/youtube/start';
export const STRAVA_OAUTH_START_PATH = '/strava/start';

interface SocialOAuthStartParams {
  intent?: SocialOAuthIntent;
  next?: string;
}

function socialOAuthStartUrl(path: string, params: SocialOAuthStartParams = {}): string {
  const qs = new URLSearchParams();
  if (params.intent) { qs.set('intent', params.intent); }
  if (params.next) { qs.set('next', params.next); }
  const suffix = qs.toString() ? `?${qs}` : '';
  return `${path}${suffix}`;
}

export function instagramOAuthStartUrl(params?: SocialOAuthStartParams): string {
  return socialOAuthStartUrl(INSTAGRAM_OAUTH_START_PATH, params);
}

export function instagramOnlyOAuthStartUrl(params?: SocialOAuthStartParams): string {
  return socialOAuthStartUrl(INSTAGRAM_ONLY_OAUTH_START_PATH, params);
}

export function tiktokOAuthStartUrl(params?: SocialOAuthStartParams): string {
  return socialOAuthStartUrl(TIKTOK_OAUTH_START_PATH, params);
}

export function youtubeOAuthStartUrl(params?: SocialOAuthStartParams): string {
  return socialOAuthStartUrl(YOUTUBE_OAUTH_START_PATH, params);
}

interface RuntimeConfig {
  web_base_url?: string;
}

const DEFAULT_FAVES_PUBLIC_WEB_BASE_URL = 'https://faves.xyz';

function readRuntimeConfig(): RuntimeConfig {
  if (typeof document === 'undefined') {
    return {};
  }

  const rawRuntimeConfig = document.getElementById('runtimeConfig')?.textContent;
  if (!rawRuntimeConfig) {
    return {};
  }

  try {
    return JSON.parse(rawRuntimeConfig) as RuntimeConfig;
  } catch {
    return {};
  }
}

const runtimeConfig = readRuntimeConfig();
const runtimePublicWebBaseUrl = runtimeConfig.web_base_url?.trim();

export const FAVES_PROD_BASE_URL = runtimePublicWebBaseUrl || DEFAULT_FAVES_PUBLIC_WEB_BASE_URL;
